/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Dirty_Toucan_LockInputs */

const fr_fresh_dirty_toucan_lock = /** @type {(inputs: Fresh_Dirty_Toucan_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vue d'ensemble`)
};

/**

* @param {Fresh_Dirty_Toucan_LockInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fresh_dirty_toucan_lock = /** @type {((inputs?: Fresh_Dirty_Toucan_LockInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Dirty_Toucan_LockInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fresh_dirty_toucan_lock(inputs)
});